<template>
  <div>
    <div title="视频播放" v-if="open" :close-on-click-modal="false" style="height:100%">
      <video id="myVideo" class="video-js jk-video vjs-fluid" autoplay>
        <!--                <source :src="videoUrl" :type="`video/${type}`">-->
      </video>
      <embed width="500" height="50" class="openFlash" type="application/x-shockwave-flash" />
    </div>
  </div>
</template>

<script>
import OSS from "ali-oss";
import flvjs from "flv.js";
//import Video from 'video.js'
//import video_zhCN from 'video.js/dist/lang/zh-CN.json'
//Video.addLanguage('zh-CN', video_zhCN);
export default {
  components: {},
  props: ["href"],
  data() {
    return {
      nowVideo: 0,
      open: false,
      videoUrl: "",
      myPlayer: "",
      type: "mp4",
    };
  },
  created() {},
  mounted() {},
  methods: {
    getDownUrl(fileid, href, type) {
      let url;
      type = type.toLowerCase();
      //var fileid = 'D9C01EA2C65B4A4A8DF3995FEC3EBF67'
      if (fileid) {
        let client = new OSS(this.$store.state.config.ossConfig);
        url = client.signatureUrl(fileid);
        log(url);
        // url = fileid
        this.type = type ? type : "mp4";

        if (fileid.indexOf("?up") != -1) {
          url = fileid.split("?")[0];
          this.type = "flv";
          log(url);
        }
      }
      log(this.type);

      if (href) {
        url = href;
      }

      this.videoUrl = url;
      this.initVideo();
    },
    getDownUrl1(fileid, href, type, length, is_oss) {
      //准备调用线下
      console.log(fileid);

      var url;
      console.log(is_oss);
      if (is_oss == 2) {
        if (fileid.indexOf("/") == 0) {
          fileid = fileid.substring(1, fileid.length);
        }
        console.log("天翼云");
        console.log(fileid);
        let client = new OOS.S3(this.$store.state.config.oosConfig);
        url = client.getSignedUrl("getObject", { Bucket: "sdtongren", Key: fileid });
      } else {
        if (fileid) {
          url = `${this.$store.state.config.miniUrl}${fileid}`;
          log(url);
        }
        if (href) {
          url = href;
        }
      }
      console.log(url);
      this.type = type ? type : "mp4";

      if (fileid.indexOf("?up") != -1) {
        url = fileid.split("?")[0];
        this.type = "flv";
        log(url);
      }
      this.videoUrl = url;
      this.initVideo();
    },

    initVideo() {
      var _this = this;
      var videoSize = {
        width: "100%",
        height: "100%",
      };
      if ((this.type == "flv") | (this.type == "mp4") || this.type == "mov") {
        if (flvjs.isSupported()) {
          this.$nextTick(() => {
            var videoElement = window.document.getElementById("myVideo");
            var option = {
              type: this.type,
              url: _this.videoUrl,
            };
            option.duration = this.tr_length || 100000;
            var flvPlayer = flvjs.createPlayer(option);
            videoElement.style.width = videoSize.width;
            videoElement.style.height = videoSize.height;
            videoElement.controls = "controls";
            flvPlayer.attachMediaElement(videoElement);
            //   return;
            flvPlayer.load();
            flvPlayer.play();
          });
        }
      } else {
        this.$nextTick(() => {
          this.myPlayer = videojs("myVideo", {
            sources: [
              // 视频源
              {
                src: this.videoUrl,
                type: "video/" + this.type,
              },
            ],
            language: "zh-CN",
            //techOrder: [ 'flash','html5',],// 兼容顺序
            //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
            controls: true,
            //自动播放属性,muted:静音播放
            autoplay: true,
            //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
            preload: "auto",
            //设置视频播放器的显示宽度（以像素为单位）
            width: "860px",
            //设置视频播放器的显示高度（以像素为单位）
            height: "440px",
            playbackRates: [0.5, 1, 1.25, 1.5, 2],
          });
          //this.myPlayer.src(this.videoUrl)
          //this.myPlayer.load();
          //this.myPlayer.play()
        });
      }
      //初始化视频方法
      // var _this = this;
      // this.$nextTick(() => {
      //   this.myPlayer = videojs("myVideo", {
      //     sources: [
      //       // 视频源
      //       {
      //         src: this.videoUrl,
      //         type: "video/" + this.type,
      //       },
      //     ],
      //     language: "zh-CN",
      //     //techOrder: [ 'flash','html5',],// 兼容顺序
      //     //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
      //     controls: true,
      //     //自动播放属性,muted:静音播放
      //     autoplay: true,
      //     //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
      //     preload: "auto",
      //     //设置视频播放器的显示宽度（以像素为单位）
      //     width: "860px",
      //     //设置视频播放器的显示高度（以像素为单位）
      //     height: "440px",
      //     playbackRates: [0.5, 1, 1.25, 1.5, 2],
      //   });
      //   //this.myPlayer.src(this.videoUrl)
      //   //this.myPlayer.load();
      //   //this.myPlayer.play()
      // });
    },
  },
  watch: {
    open(val) {
      if (val) {
        //  this.initVideo();
      } else {
        this.myPlayer.pause();
        this.myPlayer.dispose();
      }
    },
    videoUrl(val) {
      /*this.myPlayer.src(this.videoUrl)
                this.myPlayer.load();
                this.myPlayer.play();*/
    },
  },
};
</script>

<style scoped lang="scss"></style>
